import { render, staticRenderFns } from "./try-catch-settings.vue?vue&type=template&id=64354199&scoped=true"
import script from "./try-catch-settings.vue?vue&type=script&lang=js"
export * from "./try-catch-settings.vue?vue&type=script&lang=js"
import style0 from "./try-catch-settings.vue?vue&type=style&index=0&id=64354199&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64354199",
  null
  
)

export default component.exports